import styled from 'styled-components'

export const Image = styled.img`
    :hover{
        background-color: #F6F9FC;
        opacity: 0.5;
    }
`